/**
 * 날짜 계산 및 포맷팅 관련 순수 유틸리티 함수 모음
 */

export const daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

export const startDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

export const formatDate = (year, month, day) => {
    const yyyy = year;
    const mm = String(month + 1).padStart(2, '0');
    const dd = String(day).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

export const getTodayString = () => {
    const today = new Date();
    return formatDate(today.getFullYear(), today.getMonth(), today.getDate());
};

export const isValidDate = (dateStr) => {
    return dateStr && !isNaN(Date.parse(dateStr));
};
